export class AcademicSession {
    code: string;
    year: number;
    description: string;
    beginDate: Date;
    sessionNumber: number;
}
